import clsx from 'clsx';
import { FunctionComponent, MouseEvent } from 'react';
import styles from './InvoiceNumberLink.module.scss';

interface InvoiceNumberLinkProps {
    invoiceId?: number | null;
    invoiceNumber: string | number;
    className?: string;
    onClick?: (invoiceId: number) => void;
}

export const InvoiceNumberLink: FunctionComponent<InvoiceNumberLinkProps> = ({
    invoiceId,
    invoiceNumber,
    className,
    onClick
}) => {
    if (!invoiceId || !onClick) {
        return <>{invoiceNumber}</>;
    }

    const handleClick = (event: MouseEvent<HTMLButtonElement>) => {
        event.stopPropagation();
        onClick(invoiceId);
    };

    return (
        <button
            type="button"
            className={clsx(styles.link, className)}
            onClick={handleClick}
        >
            {invoiceNumber}
        </button>
    );
};

export default InvoiceNumberLink;
